module.exports = __webpack_public_path__ + "fontawesome-webfont.af7ae505a9eed503f8b8";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/assets/vendors/by_hands/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = ../../../../../src/assets/vendors/by_hands/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module chunks = styles